/** Brand marks for Agent install buttons (16×16, decorative). */
const brandImg = (slug, color) =>
  `<img src="https://cdn.simpleicons.org/${slug}/${color}" width="16" height="16" alt="" loading="lazy" decoding="async" />`

const brandFavicon = (origin) =>
  `<img src="${origin}/favicon.ico" width="16" height="16" alt="" loading="lazy" decoding="async" />`

export const MCP_ICONS = {
  claude: brandImg('anthropic', 'D97757'),
  chatgpt: brandFavicon('https://chatgpt.com'),
  cursor: brandImg('cursor', '000000'),
  gemini: brandImg('googlegemini', '8E75B2'),
  lovable: '<img src="https://lovable.dev/favicon.ico" width="16" height="16" alt="" loading="lazy" decoding="async" />',
  replit: brandImg('replit', 'F26207')
}
